<template>
  <div class="table-container">
    <table>
      <thead class="tablehead">
      <tr>
        <th >{{ $t('DeviceID') }}</th>
        <th >{{ $t('DeviceOS') }}</th>
        <th >{{ $t('CreationTime') }}</th>
        <th >{{ $t('ExpirationTime') }}</th>
      </tr>
      </thead>
      <tbody v-for="(items, key) in result">
      <tr v-for="item in items" :key="item.deviceId">
        <td >{{ item.deviceId }}</td>
        <td >{{ item.os}} {{item.version}} {{item.platform}}</td>
        <td >{{ item.created | moment('ddd, MMM Do YYYY') }}</td>
        <td >{{ item.trusted | moment('ddd, MMM Do YYYY') }}<v-btn class="delete" @click="deleteDevice(key, item.deviceId)">{{ $t('DeleteTrustedDevice') }}</v-btn></td>
      </tr>
      <tr v-if="hasTrustedDevices">
        <td colspan="4">
          <v-btn class="deleteAllDevices" @click="untrustAllDevices(key)">{{ $t('DeleteAllTrustedDevices') }}</v-btn>
        </td>
      </tr>
      <tr v-if="!hasTrustedDevices">
        <td colspan="6">{{ $t('No.Trusted.Devices') }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import lib from '@/library'
export default {
  name: 'DataTable',
  data () {
    return {
      result: {
        array1: [],
        array2: []
      }
    }
  },
  created () {
    this.getDevicesList()
  },
  computed: {
    hasTrustedDevices () {
      // Check if there's any data in the result object
      return Object.values(this.result).some(array => array.length > 0)
    }
  },
  methods: {
    getDevicesList () {
      lib.rpcService.callBroker('iw', 'gettrusteddevices', {}).then((response) => {
        if (response && response.result) {
          this.result = response.result
        } else {
          this.result = undefined
        }
      }).catch((error) => {
        this.error = error
      })
    },
    async deleteDevice (arrayKey, itemId) {
      const array = this.result[arrayKey]
      if (!array) return
      const index = array.findIndex(item => item.deviceId === itemId)
      if (index === -1) return

      array.splice(index, 1)

      try {
        const response = lib.rpcService.callBroker('iw', 'untrustdevice', { deviceId: itemId })
        if (response && response.result) {
          console.log('Device deleted successfully on the server:', response.result)
        } else {
          console.log('Untrust device - Server responded with an error or empty result')
        }
      } catch (error) {
        console.error('Error deleting item on the server:', error)
      }
    },
    async untrustAllDevices () {
      if (!this.result || Object.keys(this.result).length === 0) {
        return
      }
      try {
        for (const key in this.result) {
          const items = this.result[key]
          for (const item of items) {
            const response = await lib.rpcService.callBroker('iw', 'untrustdevice', {
              deviceId: item.deviceId
            })

            if (response && response.result) {
              console.log('Devices deleted successfully on the server:', response.result)
            } else {
              console.log('Untrust devices - Server responded with an error or empty result')
            }
          }
          this.result[key] = []
        }
      } catch (error) {
        console.error('Error deleting item on the server:', error)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/css/config'
@import '~@/css/mixins'

.table-container
  overflow-x auto
  border: var(--account-summary-boxes-border)
  background: var(--account-summary-boxes-bgr) !important
  border-radius: var(--account-summary-boxes-border-radius) !important
  color: var(--account-summary-boxes-color) !important

table
  width 100%
  border-collapse collapse
th, td
  padding 8px
  text-align center
th
  background: var(--account-pages-table-headers-bgr) !important

@media mobile-big-and-below
  table
    display block
    width 100%
    overflow-x auto
    -webkit-overflow-scrolling touch

  thead
    display none

  tbody
    display block
    width 100%

  tr
    display flex
    flex-direction column
    border-bottom 1px solid #ddd

  td
    display block
    width 100%
    box-sizing border-box

  tr:last-child
    border-bottom none

  button.delete
    margin-left 40px
thead.tablehead
  background: var(--account-pages-table-headers-bgr) !important
  color var(--account-pages-table-headers-color) !important

button.delete
  background: var(--account-pages-secondary-btn-bgr) !important
  border:  var(--account-pages-secondary-btn-border)
  color: var(--account-pages-secondary-btn-color)!important
  border-radius var(--account-pages-btn-border-radius) !important
.deleteAllDevices
  background: var(--account-pages-primary-btn-bgr) !important
  border:  var(--account-pages-primary-btn-border)
  color: var(--account-pages-primary-btn-color)!important
  border-radius var(--account-pages-btn-border-radius) !important



</style>



// WEBPACK FOOTER //
// src/components/account/IntegratedWallet/MyDevices.vue